import { render, staticRenderFns } from "./StateForm.vue?vue&type=template&id=31c9e72a&scoped=true&"
import script from "./StateForm.vue?vue&type=script&lang=js&"
export * from "./StateForm.vue?vue&type=script&lang=js&"
import style0 from "./StateForm.vue?vue&type=style&index=0&id=31c9e72a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c9e72a",
  null
  
)

export default component.exports